import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { first, isEmpty } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Tag from 'components/forms/Tag';
import { sequenceTabUrl } from 'constants/routing';
import { ReactComponent as SequenceIcon } from 'icons/sequence.svg';
import { Link } from 'react-router-dom';
import TableRow from 'components/tables/tableRow';
import TableCell from 'components/tables/tableCell';
import Checkbox from 'components/forms/Checkbox';
import MessageOutlineIcon from 'mdi-react/MessageOutlineIcon';
import {
  getErrorText, getFullName,
  getReplyStatus,
} from 'utils/contact';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import DotsVerticalIcon from 'mdi-react/DotsVerticalIcon';
import { AbilityContext } from 'utils/permissions';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import ReplyStatusBadge from 'components/Inbox/InboxList/ReplyStatusBadge';
import MessagesPopover from '../../MessagesPopover';
import ActionsPopover from './ActionsPopover';

const styles = () => ({
  dotsVerticalContainer: {
    display: 'inline-block',
  },
});

class ContactRow extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  static contextType = AbilityContext;

  handleDotsClick = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  handleDotsClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ anchorEl: null });
  }

  renderCurrentSequenceReply = contact => (
    <TableCell className="material-table__row__cell rectangle-cell rectangle-cell--no-hover">
      {!isEmpty(contact.replies) &&
        <ReplyStatusBadge status={getReplyStatus(first(contact.replies)).statusCode} />
      }
    </TableCell>
  )

  renderAllReplies = (contact) => {
    const { parentComponentId } = this.props;
    const popoversReplyId = `popover-replies-${parentComponentId}-${contact.id}`;
    return (
      <TableCell className="material-table__row__cell rectangle-cell">
        {contact.replies.length > 0 && (
          <React.Fragment>
            <div
              className="rectangle-cell__item"
              role="button"
              id={popoversReplyId}
            >
              <MessageOutlineIcon />
              ({contact.replies.length})
            </div>
            <MessagesPopover uuid={parentComponentId} seqContact={contact} />
          </React.Fragment>
        )}
      </TableCell>
    );
  }

  renderContactErrors = (contact) => {
    const { parentComponentId } = this.props;
    const popoversErrorId = `popover-errors--${parentComponentId}-${contact.id}`;
    return (
      <React.Fragment>
        <div
          role="button"
          className="rectangle-cell__item"
          id={popoversErrorId}
          onClick={event => event.stopPropagation()}
          tabIndex="-1"
          onKeyDown={() => {}}
        >
          <AlertOutlineIcon size={20} />
          ({contact.errors.length})
        </div>
        <UncontrolledPopover
          className="zindex-modal sequence-create__contacts-ready__popover"
          trigger="legacy"
          placement="auto"
          target={popoversErrorId}
          delay={0}
          role="tooltip"
        >
          <PopoverBody>
            {contact.errors.map((err, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={i}>
                {getErrorText(err)}
                {i + 1 !== contact.errors.length && <hr className="mtb-25" />}
              </React.Fragment>
            ))}
          </PopoverBody>
        </UncontrolledPopover>
      </React.Fragment>
    );
  };

  renderSteps = contact => (
    <TableCell>
      <div className="pill-steps">
        <span>{contact.current_step}</span>
        <span>{contact.total_steps}</span>
      </div>
    </TableCell>
  );

  renderPopoverActions = (contact) => {
    const { anchorEl } = this.state;
    const {
      parentComponentId,
      getContacts,
      showNotification,
      classes,
    } = this.props;
    const popoversActionId = `popover-actions-${parentComponentId}-${contact.id}`;
    return (
      <React.Fragment>
        <div
          className={classes.dotsVerticalContainer}
          id={popoversActionId}
          onClick={this.handleDotsClick}
          role="button"
          tabIndex="-1"
          onKeyDown={() => {}}
        >
          <DotsVerticalIcon />
        </div>
        <ActionsPopover
          anchorEl={anchorEl}
          contact={contact}
          getContacts={getContacts}
          showNotification={showNotification}
          handleClose={this.handleDotsClose}
        />
      </React.Fragment>
    );
  }
  render() {
    const {
      seqContact,
      isSelected,
      showContactReplyForCurrentSequence,
      fieldsToShow,
    } = this.props;

    return (
      <TableRow
        className="material-table__row"
        role="checkbox"
        onClick={this.props.toggleContactEditModal}
        // prevent text selection during shift + click
        onMouseDown={event => event.shiftKey && event.preventDefault()}
        aria-checked={isSelected}
        tabIndex={-1}
        key={seqContact.id}
        selected={isSelected}
      >
        <TableCell className="material-table__row__cell position-relative flex flex-col justify-center text-sm whitespace-nowrap">
          <Checkbox
            checked={isSelected}
            onClick={event => this.props.handleSelectClick(event, seqContact.id)}
            style={{ position: 'absolute', top: 8, left: 8 }}
          />
          {getFullName(seqContact)}
        </TableCell>
        {fieldsToShow.email.show && (
          <TableCell className="material-table__row__cell">{seqContact.email}</TableCell>
        )}
        {fieldsToShow.outlet.show && (
          <TableCell className="material-table__row__cell">{seqContact.outlet.name}</TableCell>
        )}
        {fieldsToShow.recentSequence.show && (
          !isEmpty(seqContact.recent_sequence) ? (
            <TableCell className="material-table__row__cell rectangle-cell">
              <Tag
                icon={<SequenceIcon />}
                color="gray"
                className="h-5 min-w-[3rem]"
                label={
                  this.context.can('see', 'Sequence') ?
                    <Link
                      className="text-[--secondary-900] no-underline hover:text-[--secondary-900] focus:text-[--secondary-900] visited:text-[--secondary-900] active:text-[--secondary-900]"
                      to={sequenceTabUrl(seqContact.recent_sequence.id)}
                      target="_blank"
                      onClick={event => event.stopPropagation()}
                    >
                      {seqContact.recent_sequence.name}
                    </Link> : seqContact.recent_sequence.name
                }
              />
            </TableCell>
          ) : (
            <TableCell className="material-table__row__cell rectangle-cell" />
          )
        )}
        {fieldsToShow.deliveryStatus.show && (
          <TableCell className="material-table__row__cell rectangle-cell rectangle-cell--no-hover">
            {seqContact.delivery_status && (
              <ReplyStatusBadge status={seqContact.delivery_status} />
            )}
          </TableCell>
        )}
        {fieldsToShow.inboxCategory.show && (
          showContactReplyForCurrentSequence
            ? this.renderCurrentSequenceReply(seqContact)
            : this.renderAllReplies(seqContact)
        )}
        {fieldsToShow.errors.show && (
          <TableCell className="material-table__row__cell rectangle-cell">
            {seqContact.errors.length > 0
              ? this.renderContactErrors(seqContact)
              : <div className="rectangle-cell--always-space" />}
          </TableCell>
        )}
        {fieldsToShow.contactSubject.show && (
          <TableCell className="material-table__row__cell whitespace-nowrap">
            {seqContact.contact_subject}
          </TableCell>
        )}
        {fieldsToShow.outletType.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.outlet_type}
          </TableCell>
        )}
        {fieldsToShow.uvpm.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.unique_monthly_visitors}
          </TableCell>
        )}
        {fieldsToShow.audience.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.audience}
          </TableCell>
        )}
        {fieldsToShow.da.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.domain_authority}
          </TableCell>
        )}
        {fieldsToShow.country.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.country}
          </TableCell>
        )}
        {fieldsToShow.dma.show && (
          <TableCell className="material-table__row__cell">
            {seqContact.outlet.dma}
          </TableCell>
        )}
        <TableCell className="material-table__row__cell dots-actions text-right">
          {this.renderPopoverActions(seqContact)}
        </TableCell>
      </TableRow>
    );
  }
}

ContactRow.propTypes = {
  seqContact: PropTypes.shape({}).isRequired,
  // using inheritance instead of redux because we need existing search filters
  getContacts: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  parentComponentId: PropTypes.string.isRequired,
  handleSelectClick: PropTypes.func.isRequired,
  showContactReplyForCurrentSequence: PropTypes.bool,
  classes: PropTypes.element.isRequired,
  toggleContactEditModal: PropTypes.func.isRequired,
  fieldsToShow: PropTypes.shape({}).isRequired,
};

ContactRow.defaultProps = {
  showContactReplyForCurrentSequence: false,
};

export default withStyles(styles)(ContactRow);
